import { render, staticRenderFns } from "./ACard.vue?vue&type=template&id=1176492c"
import script from "./ACard.vue?vue&type=script&lang=js"
export * from "./ACard.vue?vue&type=script&lang=js"
import style0 from "./ACard.vue?vue&type=style&index=0&id=1176492c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports